export default __webpack_public_path__ + "static/splash-b3a8b1f5e0b7e7988e21c61802ab7ae7.png";